/* =====================================================================================
   DC 25/10/2026 : PANNEAU D'AJOUT RAPIDE — comportement.
   Chargé seulement là où l'interrupteur de snippets/dc-panneau-rapide.liquid ouvre un endroit (étape 1 :
   grilles collection, recherche, 404) ; ce snippet porte aussi le style et le gabarit du panneau.
   Repris des maquettes validées par Marco le 25/10 (scratchpad quickadd : finale/maquette/melange.js pour le
   téléphone et les règles, place-panier/maquette/melange-place-panier.js pour l'ordinateur).

   LE CERCLE (snippets/dc-panneau-rapide-cercle.liquid) porte le choix fait côté Shopify :
   - data-dcpr-mode="direct" : un seul format disponible, pas en retrait -> ajout DIRECT en un toucher par le
     circuit Horizon actuel : le formulaire de la carte (assets/product-form.js), donc la garde de stock de
     snippets/dc-cards.liquid, la propriété Retrait de snippets/dc-retrait.liquid, l'image qui vole et le
     panier DC qui s'ouvre restent exactement ceux d'aujourd'hui ;
   - data-dcpr-mode="panneau" : plusieurs formats disponibles, ou un seul en retrait magasin -> le PANNEAU.
   Aucune règle n'est refaite ici : stock lu dans le JSON data-dc-cardinv de la carte, formats en retrait
   dans data-dc-retrait-ids (règle unique snippets/dc-est-retrait.liquid).

   LE PANNEAU (contenu identique partout) : photo, marque, nom, prix du format choisi + « TVA incluse », ligne
   de stock (phrases de dc-glass), formats en pastilles avec leur prix, quantité plafonnée au stock moins le
   panier, bouton « Ajouter · prix », lien vers la fiche. Deux dispositions :
   - .is-sheet (téléphone, tablette en portrait) : monte du bas, voile léger, poignée (glisser vers le bas
     ferme), le cercle d'origine devient « × » ; après l'ajout : « ✓ Ajouté », l'image vole APRÈS l'accord du
     panier, le panneau se ferme et le panier DC s'ouvre comme aujourd'hui ;
   - .is-dock (ordinateur, tablette en paysage) : à la place du panier DC (même place, calculée par
     window.DCPanier.place() de snippets/dc-cart.liquid, même verre, même voile html.dc-mm-open) ; clic dehors =
     fermer ; après l'ajout : « ✓ Ajouté » bref, puis le panneau DEVIENT le panier DC au même endroit (relais :
     le contenu s'efface, puis fondu enchaîné des deux verres) ; pas d'image qui vole.
   Ajout depuis le panneau : /cart/add.js { id, quantity[, properties.Retrait] }, contrôlé par la garde de
   stock de dc-cards (rendue muette le temps de l'ajout : le refus s'écrit DANS le panneau, sans doublon) ;
   puis cart:update avec la source « dc-panneau-rapide » et itemCount = TOTAL du panier (cart-icon.js n'ajoute
   la quantité que pour la source 'product-form-component' : la pastille ne compte jamais deux fois).
   Accessibilité : dialogue aria-modal, focus gardé dedans, Échap ferme, focus rendu au cercle, flèches entre
   les formats.
   API (essais) : window.DCPanneauRapide = { gere(carte), toucher(cercle), fermer(), choisir(id), qte(n),
   ajouter(), etat() }.
   DC 04/11/2026, Marco (fiche « Le fil ») : aussi les cartes de la FICHE (.fx-carte : Le matériel et conseils de la frise des
   7 étapes, snippets/dc-fiche-carte.liquid). Elles n'ont pas de formulaire Horizon : leur cercle porte titre, photo, formats en
   retrait et, hors Belgique, formats masqués (data-dcpr-masquer : jamais proposés). Ajout DIRECT (un seul format, pas en
   retrait) par directFiche(), qui passe par la MÊME fonction d'envoi que le panneau (envoyer() : /cart/add.js, garde de stock
   de dc-cards, quantité réellement envoyée, cart:update, panier DC) ; refus (garde, Shopify, réseau) = cercle au repos et
   panneau du produit ouvert avec la raison. Rien ne change pour les cartes de la boutique.
   DC 25/10/2026 (étape 2) : aussi « Vous aimerez aussi » de la fiche et « Vous aimeriez aussi » de /cart (cartes chargées
   après la page : tout passe par délégation sur document). Sur /cart, le panier DC ne s'ouvre pas après l'ajout (règle de
   la page) : la liste se met à jour par les sections de cart-items-component jointes à l'ajout, comme pour le formulaire
   Horizon (assets/product-form.js). Pendant le panneau, html.dcpr-ouvert masque la barre collante de la fiche.
   ===================================================================================== */
(function () {
  if (window.DCPanneauRapide) return;
  var reg = {};
  try { reg = JSON.parse((document.getElementById('dcpr-reglages') || {}).textContent || '{}') || {}; } catch (e) { reg = {}; }
  var PORTEE = reg.portee || '';
  if (!PORTEE) return;
  var RACINE = String(reg.racine || '/');
  if (RACINE.charAt(RACINE.length - 1) !== '/') RACINE += '/';
  var SOURCE = 'dc-panneau-rapide';
  var PROPVAL = 'Magasin uniquement (non expédiable)'; /* même valeur que snippets/dc-retrait.liquid */
  var RH = document.documentElement;
  /* les fenêtres DC posées sous la pilule de l'en-tête, avec le même voile (html.dc-mm-open) */
  var FEN = ['dc-mm', 'dc-mnav', 'dc-cart', 'dc-search', 'dc-acc'];

  var esc = function (t) { return String(t == null ? '' : t).replace(/[&<>"']/g, function (ch) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[ch]; }); };

  /* ---------- prix : le format monétaire de la boutique ({{ shop.money_format }}, celui du filtre money des
     cartes), reproduit ici : tout suivra quand le format sera changé dans l'admin (« €40,99 » -> « 40,99 € »). ---------- */
  var FMT = (function (f) {
    var s = String(f || '');
    try { s = new DOMParser().parseFromString(s, 'text/html').body.textContent || s; } catch (e) {}
    return s.indexOf('{{') > -1 ? s : '{{amount_with_comma_separator}} €';
  })(reg.format);
  function montant(c, dec, mil, sep) {
    var p = (Math.round(c) / 100).toFixed(dec).split('.');
    return p[0].replace(/\B(?=(\d{3})+(?!\d))/g, mil) + (dec ? sep + p[1] : '');
  }
  function prix(c) {
    c = Number(c) || 0;
    return FMT.replace(/\{\{\s*(\w+)\s*\}\}/, function (m, k) {
      switch (k) {
        case 'amount': return montant(c, 2, ',', '.');
        case 'amount_no_decimals': return montant(c, 0, ',', '.');
        case 'amount_with_comma_separator': return montant(c, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return montant(c, 0, '.', ',');
        case 'amount_with_space_separator': return montant(c, 2, ' ', ',');
        case 'amount_no_decimals_with_space_separator': return montant(c, 0, ' ', ',');
        case 'amount_with_apostrophe_separator': return montant(c, 2, "'", '.');
        case 'amount_with_period_and_space_separator': return montant(c, 2, ' ', '.');
        default: return montant(c, 2, '.', ',');
      }
    });
  }

  /* ---------- cartes et données ---------- */
  function carteDe(el) { return el && el.closest ? (el.closest('product-card') || el.closest('.product-card') || el.closest('.fx-carte')) : null; }
  function dansPortee(el) { try { return !!(el && el.closest && el.closest(PORTEE)); } catch (e) { return false; } }
  /* carte gérée par le panneau (cercle présent dans un endroit ouvert) : lu par assets/product-card.js */
  function gere(card) { var t = card && card.querySelector && card.querySelector('.dcpr-trg'); return !!(t && dansPortee(t)); }
  function lire(card, trg) {
    var qa = card.querySelector('quick-add-component');
    var inv = {}, s = card.querySelector('[data-dc-cardinv]');
    if (s) { try { inv = JSON.parse(s.textContent) || {}; } catch (e) {} }
    var img = card.querySelector('.card-gallery img') || card.querySelector('.fx-carte__mur img');
    var form = qa && qa.querySelector('product-form-component');
    var url = (trg.getAttribute('data-dcpr-url') || '').split('?')[0];
    /* DC 04/11/2026 (fiche « Le fil ») : sans quick-add-component (cartes de la fiche), titre, photo et formats en retrait sont
       lus sur le cercle lui-même (snippets/dc-panneau-rapide-cercle.liquid, paramètre fiche) */
    return {
      url: url, titre: (qa && qa.getAttribute('data-product-title')) || trg.getAttribute('data-dcpr-titre') || '',
      retrait: ((qa && qa.getAttribute('data-dc-retrait-ids')) || trg.getAttribute('data-dcpr-retrait-ids') || '').split(',').filter(Boolean),
      masquer: (trg.getAttribute('data-dcpr-masquer') || '').split(',').filter(Boolean),
      inv: inv, img: trg.getAttribute('data-dcpr-img') || (img ? (img.currentSrc || img.src || '') : ''), qa: qa, pid: form ? form.getAttribute('data-product-id') : null,
      vid: trg.getAttribute('data-dcpr-variante')
    };
  }
  var cache = {};
  function produit(url) {
    if (!cache[url]) cache[url] = fetch(url + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
      .catch(function (e) { delete cache[url]; throw e; });
    return cache[url];
  }
  function panierLu() {
    return fetch(RACINE + 'cart.js', { headers: { Accept: 'application/json' }, cache: 'no-store' })
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); });
  }
  function qtes(c) { var m = {}; ((c && c.items) || []).forEach(function (it) { var k = String(it.variant_id); m[k] = (m[k] || 0) + it.quantity; }); return m; }
  function taille(src, w) {
    if (!src) return '';
    src = String(src); if (src.indexOf('//') === 0) src = 'https:' + src;
    try { var u = new URL(src, location.href); u.searchParams.set('width', String(w)); return u.toString(); } catch (e) { return src; }
  }

  /* ---------- le cercle ---------- */
  function etat(t, s) {
    if (!t) return;
    if (s) t.setAttribute('data-state', s); else t.removeAttribute('data-state');
    if (s === 'busy') t.setAttribute('aria-busy', 'true'); else t.removeAttribute('aria-busy');
  }
  function coche(t) { if (!t) return; etat(t, 'added'); clearTimeout(t.__dcprT); t.__dcprT = setTimeout(function () { if (t.getAttribute('data-state') === 'added') etat(t, ''); }, 1600); }

  function toucher(trg, ev) {
    var card = carteDe(trg);
    if (!card || trg.getAttribute('data-state') === 'busy') return;
    if (cur && cur.trg === trg) { fermer(); return; }
    /* DC 25/10/2026 (relecture) : un autre cercle attendait encore ses formats -> il est abandonné et remis au repos
       (sinon il tournait sans fin, refusait tout toucher, et son panneau s'ouvrait après coup par-dessus ce choix) */
    if (attente && attente.trg !== trg) { etat(attente.trg, ''); attente = null; }
    /* DC 25/10/2026 (correctif, focus) : clic de souris ou toucher du doigt (detail > 0) ou clavier (Entrée, Espace : detail = 0) */
    var o = { pointeur: !!(ev && ev.detail > 0) };
    if (trg.getAttribute('data-dcpr-mode') === 'direct') return direct(card, trg, o);
    return ouvrir(card, trg, o);
  }

  /* (a) ajout direct par le formulaire Horizon de la carte (invisible, voir le style) : on y met le format
     disponible, puis on appuie sur son bouton « Ajouter », comme le « + » d'aujourd'hui. Le résultat est lu sur
     les événements du formulaire, écoutés sur window AVANT la garde de dc-cards (qui arrête cart:update en erreur). */
  function direct(card, trg, o) {
    var d = lire(card, trg);
    /* DC 04/11/2026 (fiche « Le fil ») : carte de la fiche, sans formulaire Horizon : ajout direct par la fonction d'envoi du panneau */
    if (!d.qa && card.classList && card.classList.contains('fx-carte')) return directFiche(card, trg, o, d);
    var inp = d.qa && d.qa.querySelector('input[name="id"]');
    var btn = d.qa && d.qa.querySelector('.quick-add__button--add');
    if (!inp || !btn || btn.disabled || !d.vid) return ouvrir(card, trg, o);
    inp.value = d.vid; inp.disabled = false;
    etat(trg, 'busy');
    var fini = false, minuterie = null;
    var fin = function (ok) {
      if (fini) return; fini = true; clearTimeout(minuterie);
      window.removeEventListener('cart:update', ecoute, true); window.removeEventListener('cart:error', ecoute, true);
      if (ok) coche(trg); else etat(trg, '');
    };
    var ecoute = function (e) {
      if (!e.target || !e.target.nodeType || !d.qa.contains(e.target)) return;
      var x = (e.detail && e.detail.data) || {};
      if (e.type === 'cart:error' || x.didError) { fin(false); return; }
      if (x.source === 'product-form-component') fin(true);
    };
    window.addEventListener('cart:update', ecoute, true); window.addEventListener('cart:error', ecoute, true);
    minuterie = setTimeout(function () { fin(false); }, 7000);
    btn.click();
  }

  /* ---------- le panneau ---------- */
  var P = null, V = null, RET = null, cur = null, attente = null, relais = false;
  function q(s) { return P.querySelector(s); }
  function focusables() {
    return [].slice.call(P.querySelectorAll('a[href],button:not([disabled])')).filter(function (x) { return x.tabIndex >= 0 && x.offsetParent !== null; });
  }
  /* premier arrêt du clavier dans le panneau : le format choisi, sinon « Ajouter », sinon la croix */
  function premier() { return P.querySelector('.dcpr__o[aria-checked="true"]:not(:disabled)') || P.querySelector('.dcpr__add:not(:disabled)') || P.querySelector('.dcpr__x'); }
  function autreOuvert() { return FEN.some(function (id) { var m = document.getElementById(id); return m && m.classList.contains('is-open'); }); }
  /* le voile du panier n'est retiré que si aucune fenêtre DC ne l'utilise encore */
  function liberer() { if (!autreOuvert()) RH.classList.remove('dc-mm-open'); }
  /* DC 25/10/2026 (étape 2) : panneau affiché -> la barre collante de la fiche se retire (style : html.dcpr-ouvert #dc-satc) */
  function barre(on) { RH.classList.toggle('dcpr-ouvert', !!on); }
  function tactile() { try { return window.matchMedia('(hover: none) and (pointer: coarse)').matches; } catch (e) { return false; } }
  function reduit() { try { return window.matchMedia('(prefers-reduced-motion: reduce)').matches; } catch (e) { return false; } }
  /* monte du bas : téléphone (< 750 px), écran bas, tablette tactile en portrait (ou de moins de 1000 px) ;
     sinon (ordinateur, tablette en paysage) : à la place du panier DC */
  function feuille() { var w = window.innerWidth, h = window.innerHeight; return w < 750 || h < 500 || (tactile() && (h > w || w < 1000)); }

  function coquille() {
    if (P) return P;
    var tpl = document.getElementById('dcpr-gabarit');
    if (!tpl || !tpl.content) return null;
    var frag = tpl.content.cloneNode(true);
    V = frag.querySelector('.dcpr-voile'); P = frag.querySelector('.dcpr'); RET = frag.querySelector('.dcpr__ret');
    if (RET && RET.parentNode) RET.parentNode.removeChild(RET);
    document.body.appendChild(V); document.body.appendChild(P);
    V.addEventListener('click', function () { fermer(); });
    /* le voile du téléphone ne fait pas défiler la page derrière lui */
    V.addEventListener('touchmove', function (e) { if (e.cancelable) e.preventDefault(); }, { passive: false });
    P.addEventListener('click', function (e) {
      var t = e.target;
      if (P.__glisse) { P.__glisse = false; e.preventDefault(); return; } /* fin d'un glisser : pas un toucher */
      if (t.closest('.dcpr__x')) { fermer(); return; }
      var o = t.closest('.dcpr__o'); if (o && !o.disabled) { choisir(o.getAttribute('data-v')); return; }
      var b = t.closest('[data-q]'); if (b && !b.disabled && cur) { qte(cur.q + parseInt(b.getAttribute('data-q'), 10)); return; }
      if (t.closest('.dcpr__add')) ajouter();
    });
    P.addEventListener('keydown', function (e) {
      /* focus gardé dans le panneau (dialogue modal) */
      if (e.key === 'Tab' && cur) {
        /* DC 25/10/2026 (correctif, focus) : panneau ouvert au pointeur (le focus est sur le panneau lui-même) : le premier
           Tab mène au format choisi, avec son contour ; Maj+Tab mène au dernier élément, comme avant */
        if (document.activeElement === P && !e.shiftKey) { var g = premier(); if (g) { e.preventDefault(); try { g.focus(); } catch (x) {} } return; }
        var f = focusables();
        if (f.length) {
          var i = f.indexOf(document.activeElement);
          if (e.shiftKey && i <= 0) { e.preventDefault(); f[f.length - 1].focus(); }
          else if (!e.shiftKey && i === f.length - 1) { e.preventDefault(); f[0].focus(); }
        }
        return;
      }
      /* flèches dans le groupe des formats (boutons radio à focus itinérant) */
      var o = e.target.closest && e.target.closest('.dcpr__o');
      if (!o || ['ArrowRight', 'ArrowLeft', 'ArrowDown', 'ArrowUp'].indexOf(e.key) < 0) return;
      var all = [].slice.call(P.querySelectorAll('.dcpr__o:not(:disabled)')), i2 = all.indexOf(o);
      var n = all[(i2 + (e.key === 'ArrowRight' || e.key === 'ArrowDown' ? 1 : all.length - 1)) % all.length];
      if (n) { e.preventDefault(); choisir(n.getAttribute('data-v')); n.focus(); }
    });
    glisser();
    return P;
  }

  /* glisser vers le bas pour fermer (poignée et haut du panneau, quand il monte du bas) */
  function glisser() {
    var y0 = 0, t0 = 0, dy = 0, actif = false, id = null;
    P.addEventListener('pointerdown', function (e) {
      if (!cur || !cur.sheet || e.button > 0) return;
      if (!e.target.closest('.dcpr__drag, .dcpr__grip, .dcpr__head') || e.target.closest('.dcpr__x')) return;
      var sc = q('.dcpr__in'); if (sc && sc.scrollTop > 0) return;
      actif = true; y0 = e.clientY; t0 = e.timeStamp || Date.now(); dy = 0; id = e.pointerId;
      try { P.setPointerCapture(id); } catch (x) {}
    });
    P.addEventListener('pointermove', function (e) {
      if (!actif) return;
      dy = Math.max(0, e.clientY - y0);
      if (dy > 4) { P.classList.add('is-dragging'); P.style.transform = 'translateY(' + dy + 'px)'; }
    });
    var fin = function (e) {
      if (!actif) return; actif = false;
      try { P.releasePointerCapture(id); } catch (x) {}
      var dt = Math.max(1, (e.timeStamp || Date.now()) - t0), v = dy / dt;
      P.classList.remove('is-dragging');
      if (dy > 4) P.__glisse = true;
      setTimeout(function () { P.__glisse = false; }, 400);
      P.style.transform = '';
      if (dy > 80 || (dy > 24 && v > 0.6)) fermer();
    };
    P.addEventListener('pointerup', fin);
    P.addEventListener('pointercancel', fin);
  }

  function rec(v, me) {
    me = me || cur;
    var qn = me.d.inv[String(v.id)];
    return { a: v.available !== false, q: (qn === null || qn === undefined) ? null : Number(qn), r: me.d.retrait.indexOf(String(v.id)) > -1 };
  }
  function dispoV(v, me) { var r = rec(v, me); return r.a && !(r.q !== null && r.q <= 0); }
  function maxi() { var r = rec(cur.v); return r.q === null ? 99 : Math.max(0, r.q - (cur.inCart || 0)); }
  /* DC 29/10/2026 (décisions de Marco) : mêmes mots, même seuil et même 2e ligne que la fiche et les cartes, lus dans le
     vocabulaire unique window.dcStock (snippets/dc-glass.liquid, rendu dans le <head>) : « En stock », « Plus que 2 en
     stock », « Dernier en stock », « Épuisé », puis « Retrait gratuit à Tubize, prêt sous 24 h » (Belgique). Plus de nombre
     au-dessus du seuil ni de délai d'expédition. Restent propres au panneau : les messages « déjà dans votre panier ».
     Renvoie [état, mot, 2e ligne (HTML de snippets/dc-port-tarifs.liquid, ou vide)]. */
  function stockTxt(r, m) {
    var DS = window.dcStock, vide = r.a === false || (r.q !== null && r.q <= 0);
    var e = DS ? DS.etat(r) : { st: vide ? 'out' : 'in', mot: vide ? 'Épuisé' : 'En stock', suite: '' };
    if (e.st !== 'out' && m <= 0 && cur.inCart > 0) /* tout le stock de ce format est déjà au panier */
      return ['full', r.q === 1 ? 'Le dernier est déjà dans votre panier' : (DS && r.q <= DS.seuil ? 'Les ' + r.q + ' derniers sont déjà dans votre panier' : 'Tout le stock de ce format est déjà dans votre panier'), ''];
    return [e.st, e.mot, e.suite || ''];
  }
  function imageDe(v, me) { return (v && v.featured_image && v.featured_image.src) ? taille(v.featured_image.src, 600) : (me.d.img || taille(me.p.featured_image, 600)); }

  /* remplit le panneau pour le produit ouvert (une fois par ouverture) */
  function construire() {
    var p = cur.p, d = cur.d;
    var lien = d.url || p.url;
    q('.dcpr__img').setAttribute('href', lien);
    var t = q('.dcpr__t'); t.setAttribute('href', lien); t.textContent = d.titre || p.title || '';
    q('.dcpr__ven').textContent = p.vendor || '';
    q('.dcpr__img img').removeAttribute('src');
    var opts = p.variants || [], plusieurs = opts.length > 1;
    var noms = (p.options || []).map(function (o) { return typeof o === 'string' ? o : (o && o.name); }).filter(function (n) { return n && n !== 'Title'; });
    var nomOpt = noms.length ? noms.join(' / ') : 'Format';
    var fl = q('.dcpr__fl'), fo = q('.dcpr__fo'), one = q('.dcpr__one');
    fo.textContent = ''; one.textContent = '';
    fl.hidden = !plusieurs; fo.hidden = !plusieurs; one.hidden = plusieurs;
    if (plusieurs) {
      fl.textContent = nomOpt;
      /* DC 03/11/2026 — nouvelles cartes (stock intégré), décision de Marco : le même repère que la ligne de stock des cartes
         et les boutons de format de la fiche : un format en stock à 2 pièces ou moins (seuil du thème, window.dcStock) prend
         la classe dcpr__o--peu (contour et point ambre, snippets/dc-panneau-rapide.liquid) ; les lecteurs d'écran l'entendent. */
      var seuil = (window.dcStock && typeof window.dcStock.seuil === 'number') ? window.dcStock.seuil : 2;
      opts.forEach(function (x) {
        var off = !dispoV(x);
        var rx = rec(x), peu = !off && rx.q !== null && rx.q > 0 && rx.q <= seuil;
        var b = document.createElement('button');
        b.type = 'button'; b.className = 'dcpr__o' + (peu ? ' dcpr__o--peu' : ''); b.tabIndex = -1;
        b.setAttribute('role', 'radio'); b.setAttribute('aria-checked', 'false'); b.setAttribute('data-v', String(x.id));
        if (off) { b.disabled = true; b.setAttribute('aria-disabled', 'true'); }
        if (peu) b.title = rx.q === 1 ? 'Dernier en stock' : 'Plus que ' + rx.q + ' en stock';
        var bb = document.createElement('b'); bb.textContent = x.title;
        if (peu) { var vh = document.createElement('span'); vh.className = 'visually-hidden'; vh.textContent = ' (' + b.title.toLowerCase() + ')'; bb.appendChild(vh); }
        var sm = document.createElement('small'); sm.textContent = off ? 'Épuisé' : prix(x.price);
        b.appendChild(bb); b.appendChild(sm); fo.appendChild(b);
      });
    } else {
      var v0 = opts[0] || {};
      one.appendChild(document.createTextNode(nomOpt + ' : '));
      var b0 = document.createElement('b'); b0.textContent = (!v0.title || v0.title === 'Default Title') ? 'unique' : v0.title; one.appendChild(b0);
    }
    var rw = q('.dcpr__retw'); rw.textContent = ''; rw.__k = false;
    var add = q('.dcpr__add'); add.removeAttribute('data-state'); add.removeAttribute('aria-busy');
    P.classList.remove('is-busy', 'is-relais', 'is-retrait', 'is-dragging');
    P.style.transform = '';
    maj();
  }
  /* met à jour ce qui change ; le focus reste sur l'élément touché (ou passe au voisin s'il s'éteint) */
  function maj() {
    var d = cur.d, v = cur.v;
    var ae = document.activeElement, dedans = P.contains(ae) && ae !== P;
    var im = q('.dcpr__img img'), src = imageDe(v, cur);
    if (src && im.getAttribute('src') !== src) im.setAttribute('src', src);
    q('.dcpr__pr b').textContent = prix(v.price);
    var s = q('.dcpr__pr s');
    if (v.compare_at_price > v.price) { s.hidden = false; s.textContent = prix(v.compare_at_price); } else s.hidden = true;
    var r = rec(v), m = maxi(), dv = dispoV(v), st = stockTxt(r, m);
    var sk = q('.dcpr__stock'); sk.className = 'dcpr__stock ' + st[0];
    var sb = sk.querySelector('b'); if (sb.textContent !== st[1]) sb.textContent = st[1];
    var ss = sk.querySelector('small'); if (ss.innerHTML !== st[2]) ss.innerHTML = st[2];
    [].forEach.call(P.querySelectorAll('.dcpr__o'), function (o) { var on = o.getAttribute('data-v') === String(v.id); o.setAttribute('aria-checked', on ? 'true' : 'false'); o.tabIndex = on ? 0 : -1; });
    /* une seule mention du retrait, quand le format CHOISI est en retrait (rien avant le choix, décision du 20/10) */
    P.classList.toggle('is-retrait', !!r.r);
    var rw = q('.dcpr__retw');
    if (rw.__k !== !!r.r) { rw.textContent = ''; if (r.r && RET) rw.appendChild(RET.cloneNode(true)); rw.__k = !!r.r; }
    var off = !dv || m <= 0;
    q('.dcpr__q span').textContent = off ? '0' : String(cur.q);
    q('[data-q="-1"]').disabled = off || cur.q <= 1;
    q('[data-q="1"]').disabled = off || cur.q >= m;
    var add = q('.dcpr__add'); add.disabled = off;
    if (add.getAttribute('data-state') !== 'added') q('.dcpr__lbl').innerHTML = off ? (m <= 0 && dv ? 'Maximum atteint' : 'Épuisé') : 'Ajouter <em>· ' + esc(prix(v.price * cur.q)) + '</em>';
    var ht = cur.warn ? cur.warn : (dv && r.q !== null && m > 0 && cur.q >= m ? (cur.inCart ? cur.inCart + ' déjà au panier · ' : '') + m + ' au maximum pour ce format' : '');
    var hn = q('.dcpr__hint'); hn.classList.toggle('warn', !!cur.warn); if (hn.textContent !== ht) hn.textContent = ht;
    q('.dcpr__more').setAttribute('href', (d.url || cur.p.url) + '?variant=' + v.id);
    if (dedans && (!P.contains(document.activeElement) || document.activeElement === document.body || ae.disabled)) {
      var ordre = ae.matches('[data-q="1"]') ? ['[data-q="-1"]', '.dcpr__add', '.dcpr__o[aria-checked="true"]', '.dcpr__more', '.dcpr__x']
        : ae.matches('[data-q="-1"]') ? ['[data-q="1"]', '.dcpr__add', '.dcpr__o[aria-checked="true"]', '.dcpr__more', '.dcpr__x']
        : ['.dcpr__o[aria-checked="true"]', '[data-q="-1"]', '.dcpr__more', '.dcpr__x'];
      for (var i = 0; i < ordre.length; i++) { var e = q(ordre[i]); if (e && !e.disabled) { try { e.focus({ preventScroll: true }); } catch (x) {} break; } }
    }
    /* la feuille a pu grandir (aide « … au maximum », pastille du retrait) : la carte d'origine reste au-dessus */
    if (cur.sheet && !P.hidden) degager();
  }
  /* pendant l'envoi et « ✓ Ajouté » (.is-busy), format et quantité ne bougent plus */
  function occupe() { return !!(P && P.classList.contains('is-busy')); }
  function choisir(id) {
    if (!cur || occupe()) return;
    var v = cur.p.variants.filter(function (x) { return String(x.id) === String(id); })[0];
    if (!v) return;
    cur.v = v; cur.warn = ''; cur.q = 1; cur.inCart = cur.cart[String(v.id)] || 0;
    maj();
  }
  function qte(n) { if (!cur || occupe()) return; cur.q = Math.max(1, Math.min(n, maxi() || 1)); cur.warn = ''; maj(); }

  /* disposition : feuille (bas de l'écran) ou à la place du panier DC */
  function appliquerMode() {
    var f = feuille();
    cur.sheet = f;
    P.classList.toggle('is-sheet', f); P.classList.toggle('is-dock', !f);
    if (cur.trg) cur.trg.classList.toggle('is-x', f);
    V.hidden = !f;
    if (f) liberer(); else RH.classList.add('dc-mm-open');
  }
  /* à la place du panier : même calcul que place() de snippets/dc-cart.liquid (bas de la pilule + 8 px), refait
     au défilement et au redimensionnement comme lui */
  function placer() {
    if (!cur) return;
    var m = (window.DCPanier && typeof window.DCPanier.place === 'function') ? window.DCPanier.place() : null;
    if (cur.sheet) {
      /* DC 25/10/2026 (relecture) : la feuille ne monte jamais sous la pilule de l'en-tête collant (z-index 80, au-dessus
         d'elle : poignée, « × » et photo devenaient inaccessibles sur un petit iPhone) ; hauteur VISIBLE de la fenêtre
         (innerHeight), pas 100vh, plus grand sur Safari iOS quand ses barres sont affichées */
      P.style.top = '';
      var bas = parseFloat(getComputedStyle(P).bottom) || 8;
      P.style.maxHeight = Math.max(240, Math.floor(window.innerHeight - bas - (m ? m.haut : 8))) + 'px';
      return;
    }
    P.style.top = (m ? m.haut : 8) + 'px';
    P.style.maxHeight = (m ? m.hauteurMax : Math.max(260, window.innerHeight - 20)) + 'px';
  }
  /* DC 25/10/2026 (relecture) : feuille du bas -> la carte d'origine et son « × » restent visibles au-dessus du panneau
     (maquette validée). Si le panneau les recouvre, la page défile juste ce qu'il faut, sans faire passer le cercle sous
     l'en-tête ; s'il n'y a pas la place entre les deux (petit écran, panneau très haut), on laisse : le voile ferme. */
  function degager() {
    if (!cur || !cur.sheet || !cur.trg || !P || P.hidden) return;
    var bas = parseFloat(getComputedStyle(P).bottom) || 8;
    var hautP = window.innerHeight - bas - P.offsetHeight; /* haut du panneau une fois monté (offsetHeight ignore l'entrée) */
    var m = (window.DCPanier && typeof window.DCPanier.place === 'function') ? window.DCPanier.place() : null;
    var r = cur.trg.getBoundingClientRect();
    var besoin = r.bottom + 12 - hautP;
    if (besoin <= 0 || r.width === 0) return;
    /* pas la place pour le cercle entier entre la pilule et le panneau : on ne fait pas défiler pour rien */
    if (hautP - (m ? m.haut : 8) < r.height + 16) return;
    var d = Math.min(besoin, r.top - (m ? m.haut : 8));
    if (d <= 0) return;
    try { window.scrollBy({ top: d, left: 0, behavior: reduit() ? 'auto' : 'smooth' }); } catch (e) { window.scrollBy(0, d); }
  }
  function ouvrir(card, trg, opts) {
    opts = opts || {};
    var d = lire(card, trg);
    if (!coquille()) { location.href = d.url; return Promise.resolve(null); }
    if (cur) fermerVite();
    var me = { card: card, trg: trg, d: d, p: null, v: null, q: 1, inCart: 0, warn: '', cart: {} };
    /* DC 25/10/2026 (relecture) : l'attente précédente (autre cercle) est abandonnée, son cercle remis au repos */
    if (attente && attente !== me) etat(attente.trg, '');
    attente = me; etat(trg, 'busy');
    return Promise.all([produit(d.url), panierLu().then(qtes).catch(function () { return {}; })]).then(function (res) {
      if (attente !== me) return null;
      attente = null; etat(trg, '');
      me.p = res[0]; me.cart = res[1];
      /* DC 04/11/2026 (fiche « Le fil ») : hors Belgique, les formats en retrait magasin ne sont pas proposés (copie du produit :
         l'objet gardé en mémoire n'est jamais modifié) */
      if (d.masquer && d.masquer.length && me.p && me.p.variants) {
        var garde = me.p.variants.filter(function (x) { return d.masquer.indexOf(String(x.id)) < 0; });
        /* DC 04/11/2026 (contrôle 1) : TOUS les formats masqués (aucun proposable dans ce marché) : jamais de panneau qui
           proposerait le retrait ; la fiche du produit, qui le dit (« Retrait en magasin uniquement »). Les appelants actuels
           (Le matériel, la frise) exigent déjà un format proposable : filet pour un futur appelant. */
        if (!garde.length) { location.href = d.url; return null; }
        var cp = {}; for (var k in me.p) cp[k] = me.p[k]; cp.variants = garde; me.p = cp;
      }
      /* à la place du panier : une seule fenêtre sous la pilule (le panier, la recherche ou le menu se ferment) */
      if (!feuille() && window.DCPanier) {
        try { if (window.DCPanier.estOuvert()) window.DCPanier.fermer(); if (window.DCPanier.fermerAutres) window.DCPanier.fermerAutres(); } catch (e) {}
      }
      cur = me;
      var dispo = me.p.variants.filter(function (x) { return dispoV(x, me); });
      /* format présélectionné : le premier disponible hors retrait ; le bidon seulement s'il est le seul */
      var horsRetrait = dispo.filter(function (x) { return me.d.retrait.indexOf(String(x.id)) < 0; });
      var v = (opts.variante && me.p.variants.filter(function (x) { return String(x.id) === String(opts.variante); })[0]) || horsRetrait[0] || dispo[0] || me.p.variants[0];
      me.v = v; me.inCart = me.cart[String(v.id)] || 0;
      trg.setAttribute('aria-expanded', 'true');
      appliquerMode();
      construire(); P.hidden = false; barre(true); placer();
      void P.offsetWidth; /* l'état de départ de l'entrée est posé avant l'ouverture */
      degager(); /* feuille du bas : la carte et son « × » restent au-dessus (sans effet à la place du panier) */
      requestAnimationFrame(function () { if (cur === me) { P.classList.add('is-open'); if (!V.hidden) V.classList.add('is-open'); } });
      /* DC 25/10/2026 (correctif, focus) : ouvert à la souris ou au doigt -> le focus va au panneau lui-même, sans contour
         (style : .dcpr:focus). Le carrousel Horizon des recommandations (assets/slideshow.js) empêche le cercle de prendre
         le focus au clic ; donné ensuite au format, Chromium le traitait comme un focus clavier et dessinait un double
         anneau épais. Ouvert au clavier (Entrée ou Espace sur le cercle) : le format choisi, comme avant. */
      var f = opts.pointeur ? P : premier();
      if (f) try { f.focus({ preventScroll: true }); } catch (e) {}
      return cur;
    }).catch(function () { if (attente === me) { attente = null; etat(trg, ''); location.href = d.url; } return null; });
  }
  function fermerVite() {
    if (cur && cur.trg) { cur.trg.setAttribute('aria-expanded', 'false'); cur.trg.classList.remove('is-x'); }
    cur = null;
    if (!P) return;
    P.classList.remove('is-open', 'is-dragging'); P.style.transform = ''; V.classList.remove('is-open');
    P.hidden = true; V.hidden = true; liberer(); barre(false);
  }
  function fermer(o) {
    o = o || {};
    if (attente) { etat(attente.trg, ''); attente = null; }
    if (!cur) return;
    var t = cur.trg, dock = !cur.sheet;
    if (t) { t.setAttribute('aria-expanded', 'false'); t.classList.remove('is-x'); }
    cur = null;
    P.classList.remove('is-open', 'is-dragging'); P.style.transform = ''; V.classList.remove('is-open');
    if (dock) liberer(); /* même fermeture que le panier DC : le voile part avec le panneau */
    setTimeout(function () { if (!cur && !relais) { P.hidden = true; V.hidden = true; barre(false); } }, 380);
    if (t && o.focus !== false) try { t.focus({ preventScroll: true }); } catch (e) {}
  }

  /* ---------- ajout depuis le panneau ---------- */
  function voler(src, img) {
    var icon = document.querySelector('.header-actions__cart-icon');
    if (!icon || !img || !src || !window.customElements || !customElements.get('fly-to-cart')) return;
    var f = document.createElement('fly-to-cart');
    f.classList.add('fly-to-cart--quick');
    f.style.setProperty('background-image', 'url(' + img + ')');
    f.style.setProperty('--start-opacity', '0');
    f.source = src; f.destination = icon;
    document.body.appendChild(f);
  }
  /* le panneau devient le panier DC au même endroit, sans glissement ni saut :
     1. son contenu s'efface (0,12 s), son verre et sa croix restent ;
     2. cart:update (data.relais) : le panier DC s'ouvre en simple fondu (DCPanier, classe .is-relais) pendant que le
        verre du panneau s'efface : jamais deux contenus l'un sur l'autre. Le voile reste posé d'un bout à l'autre.
     Le focus clavier passe ensuite sur la croix du panier. */
  function relayer(me, annoncer) {
    relais = true;
    var focusDedans = P.contains(document.activeElement);
    P.classList.add('is-relais');
    if (me.trg) me.trg.setAttribute('aria-expanded', 'false');
    cur = null;
    setTimeout(function () { if (!cur) P.classList.remove('is-open'); annoncer(true); }, 120);
    setTimeout(function () {
      relais = false;
      if (cur) return; /* un autre panneau s'est ouvert entre-temps */
      P.hidden = true; P.classList.remove('is-relais', 'is-busy');
      liberer(); barre(false);
      if (!focusDedans) return;
      if (window.DCPanier && window.DCPanier.estOuvert() && window.DCPanier.focaliser) window.DCPanier.focaliser();
      else if (me.trg) try { me.trg.focus({ preventScroll: true }); } catch (e) {}
    }, 500);
  }
  /* DC 25/10/2026 (étape 2) : sections des listes du panier présentes dans la page (cart-items-component : la liste de
     /cart), rendues par Shopify avec la réponse de l'ajout, comme le fait le formulaire Horizon (assets/product-form.js).
     DC 25/10/2026 (correctif) : SANS la liste du tiroir Horizon caché (data-drawer, rendue par la section d'en-tête) :
     ailleurs que sur /cart, l'ajout ne demande plus le rendu de tout l'en-tête avant « ✓ Ajouté » ; le tiroir se
     redessine lui-même ensuite, comme à l'étape 1. Sur /cart, rien ne change (pas de tiroir sur cette page). */
  function sectionsListes() {
    var ids = [];
    [].forEach.call(document.querySelectorAll('cart-items-component[data-section-id]:not([data-drawer])'), function (el) { var i = el.getAttribute('data-section-id'); if (i && ids.indexOf(i) < 0) ids.push(i); });
    return ids.join(',');
  }
  function apresAjout(me, v, cart, sections) {
    var annoncer = function (relai) {
      if (!cart) { if (window.DCPanier && window.DCPanier.ouvreApresAjout && window.DCPanier.ouvreApresAjout()) window.DCPanier.ouvrir(null, relai ? { relais: true } : null); return; }
      /* même événement que le thème ; itemCount = total du panier (cart-icon.js écrit alors ce total tel quel).
         DC 25/10/2026 (étape 2) : data.sections = sections jointes à l'ajout ; sur /cart, cart-items-component s'en sert pour
         redessiner la liste (nouvelle ligne, quantités, sous-total, barre de livraison) sans autre requête ni rechargement ;
         s'il n'y en a pas, il redemande lui-même sa section. snippets/dc-cart.liquid relit le nombre de lignes de référence
         (lastLines) dans resource : « Retirer » recharge toujours la page proprement ensuite. */
      document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true, detail: { resource: cart, sourceId: SOURCE,
        data: { source: SOURCE, itemCount: cart.item_count, productId: String(me.p.id), variantId: String(v.id), relais: !!relai, sections: sections || undefined } } }));
    };
    var tiroir = !!(window.DCPanier && window.DCPanier.ouvreApresAjout && window.DCPanier.ouvreApresAjout());
    if (cur === me && !me.sheet && tiroir) relayer(me, annoncer);
    else { if (cur === me) fermer(); coche(me.trg); annoncer(false); }
  }
  /* DC 04/11/2026 (fiche « Le fil ») : la fonction d'ENVOI, extraite telle quelle de ajouter() pour servir aussi l'ajout direct
     des cartes de la fiche (directFiche) : /cart/add.js { id, quantity[, properties.Retrait][, sections] }, garde de stock de
     dc-cards muette le temps de l'ajout, quantité réellement envoyée relue dans init.body, puis apresAjout() (coche, cart:update,
     panier DC). Ce qui touche au panneau passe par « ui » : ui.ici(), ui.ok(ajuste), ui.refus(message) ; ui.direct = true pour
     l'ajout direct (jamais de propriété Retrait : le mode direct exclut les formats en retrait). */
  function envoyer(me, v, qn, ui) {
    var body = { id: v.id, quantity: qn };
    if (!ui.direct && me.d.retrait.indexOf(String(v.id)) > -1) body.properties = { Retrait: PROPVAL };
    /* DC 25/10/2026 (étape 2) : sur /cart, la liste du panier est rendue avec la réponse (voir apresAjout) */
    var secs = sectionsListes(); if (secs) body.sections = secs;
    /* garde de stock de dc-cards muette le temps de cet ajout : son refus s'écrit dans le panneau, pas en bas d'écran */
    window.__dcGardeMuette = (window.__dcGardeMuette || 0) + 1;
    var lacher = function () { window.__dcGardeMuette = Math.max(0, (window.__dcGardeMuette || 1) - 1); };
    /* init gardé : quand le stock a changé entre-temps (autre onglet), la garde de stock de dc-cards réduit la quantité
       en réécrivant init.body ; on y relit la quantité réellement envoyée */
    var init = { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) };
    return fetch(RACINE + 'cart/add.js', init)
      .then(function (r) { return r.json().catch(function () { return {}; }).then(function (j) { return { ok: r.ok, j: j }; }); })
      .then(function (res) {
        lacher();
        if (!res.ok) return ui.refus((res.j && (res.j.description || res.j.message)) || 'Ce produit n’a pas pu être ajouté.');
        var mis = qn;
        try { var jb = JSON.parse(init.body); if (jb && jb.quantity != null) mis = parseInt(jb.quantity, 10) || qn; } catch (e) {}
        /* quantité réduite par la garde : dit dans le panneau (pas en bas d'écran), et lu un peu plus longtemps */
        var ajuste = mis < qn ? (mis === 1 ? 'Il n’en restait qu’un : 1 ajouté.' : 'Il n’en restait que ' + mis + ' : ' + mis + ' ajoutés.') : '';
        if (ui.ici()) ui.ok(ajuste);
        else if (ajuste && window.__dcToast) window.__dcToast(ajuste);
        var t0 = Date.now(), pause = ajuste ? 2200 : 500;
        var sections = (secs && res.j && res.j.sections) || null;
        var suite = function (cart) { setTimeout(function () { apresAjout(me, v, cart, sections); }, Math.max(0, pause - (Date.now() - t0))); };
        return panierLu().then(suite, function () { return panierLu().then(suite, function () { suite(null); }); });
      }, function () { lacher(); return ui.refus('Ce produit n’a pas pu être ajouté.'); });
  }
  function ajouter() {
    if (!cur || !cur.v) return;
    var me = cur, b = q('.dcpr__add'), v = me.v, qn = me.q;
    /* ni pendant l'envoi, ni pendant « ✓ Ajouté » : un second appui n'ajoute pas une seconde fois */
    if (!b || b.disabled || /busy|added/.test(b.getAttribute('data-state') || '')) return;
    b.setAttribute('data-state', 'busy'); b.setAttribute('aria-busy', 'true'); P.classList.add('is-busy');
    /* DC 25/10/2026 (relecture) : la réponse peut arriver après la fermeture de ce panneau, voire pendant celui d'un autre
       produit (bouton et panneau sont partagés) : on ne touche au panneau que s'il montre encore CET ajout ; sinon le
       message passe en bas d'écran (la garde de stock est restée muette) et le cercle d'origine reçoit sa coche. */
    var ici = function () { return cur === me; };
    var refus = function (msg) { /* message sobre dans le panneau, rien ne vole ; le panier est relu (autre onglet) */
      return panierLu().then(qtes).catch(function () { return me.cart; }).then(function (m) {
        if (!ici()) { if (window.__dcToast) window.__dcToast(msg); return; }
        b.removeAttribute('data-state'); b.removeAttribute('aria-busy'); P.classList.remove('is-busy');
        me.cart = m; me.inCart = m[String(v.id)] || 0; me.q = Math.max(1, Math.min(me.q, maxi() || 1)); me.warn = msg; maj();
      });
    };
    var ok = function (ajuste) {
      b.removeAttribute('aria-busy'); b.setAttribute('data-state', 'added');
      q('.dcpr__lbl').textContent = 'Ajouté';
      if (ajuste) { var hn = q('.dcpr__hint'); hn.classList.add('warn'); hn.textContent = ajuste; }
      /* au téléphone, l'image vole après l'accord du panier ; à la place du panier, rien ne vole (le panier prend sa place) */
      if (me.sheet) voler(q('.dcpr__img'), imageDe(v, me));
    };
    envoyer(me, v, qn, { ici: ici, refus: refus, ok: ok });
  }
  /* DC 04/11/2026 (fiche « Le fil ») : ajout DIRECT d'une carte de la fiche (un seul format, disponible, pas en retrait : choix
     fait côté Shopify par le cercle). Le format est relu dans /products/{handle}.js (disponible ce jour, même identifiant que
     le cercle) ; envoi par envoyer() (garde de stock, panier DC). Refus (stock déjà au panier, Shopify, réseau) : cercle au
     repos, puis le panneau du produit s'ouvre et dit pourquoi ; format introuvable ou indisponible : le panneau, comme un
     « + » à plusieurs formats ; produit illisible : sa fiche. */
  function directFiche(card, trg, o, d) {
    if (!d.vid) return ouvrir(card, trg, o);
    etat(trg, 'busy');
    var me = { card: card, trg: trg, d: d, p: null, v: null, q: 1, inCart: 0, warn: '', cart: {}, sheet: feuille() };
    var refus = function (msg) {
      etat(trg, '');
      return ouvrir(card, trg, o).then(function (c) { if (c && cur === c) { c.warn = msg; maj(); } });
    };
    produit(d.url).then(function (p) {
      var v = (p.variants || []).filter(function (x) { return String(x.id) === String(d.vid); })[0];
      if (!v || v.available === false || d.masquer.indexOf(String(v.id)) > -1) { etat(trg, ''); return ouvrir(card, trg, o); }
      me.p = p; me.v = v;
      return envoyer(me, v, 1, { direct: true, ici: function () { return false; }, refus: refus, ok: function () {} });
    }, function () { etat(trg, ''); location.href = d.url; });
  }

  /* une autre fenêtre DC s'ouvre (icône du panier, recherche, menu) : le panneau lui laisse la place.
     DC 25/10/2026 (étapes 2-3, détail a) : si elle s'ouvre PENDANT le chargement des formats d'un cercle, l'attente est
     annulée et le cercle remis au repos : le panneau ne s'ouvre plus ensuite par-dessus le panier ouvert par son icône.
     Seule l'ouverture compte (passage de fermé à ouvert), pas les autres retouches de classe d'une fenêtre déjà ouverte. */
  function guetter() {
    FEN.forEach(function (id) {
      var m = document.getElementById(id); if (!m || m.__dcprG) return; m.__dcprG = 1;
      var avant = m.classList.contains('is-open');
      try {
        new MutationObserver(function () {
          var ouvert = m.classList.contains('is-open'), vient = ouvert && !avant;
          avant = ouvert;
          if (!vient) return;
          if (attente) { etat(attente.trg, ''); attente = null; }
          if (cur && !relais) fermer({ focus: false });
        }).observe(m, { attributes: true, attributeFilter: ['class'] });
      } catch (e) {}
    });
  }

  /* ---------- écouteurs ---------- */
  document.addEventListener('click', function (e) {
    /* une fenêtre DC ouverte (panier…) vient de traiter ce clic : « clic dehors = fermer », rien d'autre */
    if (e.defaultPrevented) return;
    var t = e.target;
    /* à la place du panier : tout clic hors du panneau le ferme et ne fait rien d'autre (comme le panier DC) ;
       l'en-tête reste actif */
    if (cur && !cur.sheet && P && !P.contains(t)) {
      if (t.closest && t.closest('#header-group')) { fermer({ focus: false }); return; }
      e.preventDefault(); e.stopPropagation(); fermer(); return;
    }
    var trg = t && t.closest ? t.closest('.dcpr-trg') : null;
    if (trg && dansPortee(trg)) { e.preventDefault(); e.stopPropagation(); toucher(trg, e); }
  }, true);
  /* pré-chargement des formats : au survol, au premier contact du doigt et au focus clavier du cercle */
  ['pointerover', 'pointerdown', 'focusin'].forEach(function (ev) {
    document.addEventListener(ev, function (e) {
      var t = e.target && e.target.closest ? e.target.closest('.dcpr-trg[data-dcpr-mode="panneau"]') : null;
      if (t && dansPortee(t)) { var u = (t.getAttribute('data-dcpr-url') || '').split('?')[0]; if (u) produit(u).catch(function () {}); }
    }, true);
  });
  /* focus gardé dans le panneau ; à l'ordinateur l'en-tête reste accessible, comme quand le panier DC est ouvert */
  document.addEventListener('focusin', function (e) {
    if (!cur || !P || P.contains(e.target)) return;
    if (!cur.sheet && e.target.closest && e.target.closest('#header-group')) return;
    var f = focusables(); if (f.length) try { f[0].focus({ preventScroll: true }); } catch (x) {}
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && (cur || attente)) fermer(); });
  window.addEventListener('resize', function () {
    if (!cur) return;
    if (feuille() !== cur.sheet) { appliquerMode(); if (!V.hidden) V.classList.add('is-open'); }
    placer(); degager();
  });
  /* au défilement : place sous la pilule (à la place du panier) ou hauteur maximale de la feuille (l'en-tête bouge) */
  window.addEventListener('scroll', function () { if (cur) placer(); }, { passive: true });
  /* départ vers une autre page (lien du panneau, carte touchée pendant une attente) : la page gardée en mémoire par le
     navigateur revient fermée, et le cercle qui attendait revient au repos (DC 25/10/2026, relecture : il restait mort) */
  window.addEventListener('pagehide', function () {
    if (attente) { etat(attente.trg, ''); attente = null; }
    if (cur) fermerVite();
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', guetter); else guetter();

  window.DCPanneauRapide = {
    gere: gere, toucher: toucher, fermer: fermer, choisir: choisir, qte: qte, ajouter: ajouter, prix: prix,
    etat: function () { return cur ? { sheet: cur.sheet, variante: cur.v && cur.v.id, q: cur.q, max: maxi(), dansPanier: cur.inCart, avertissement: cur.warn } : null; }
  };
})();
